/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_No_AccountInputs */

const en_signin_no_account = /** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New to OFFSHORELABS?`)
};

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const ar_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const he_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const ur_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const es_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const fr_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const de_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const pt_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const hi_signin_no_account = en_signin_no_account;

/** @type {(inputs: Signin_No_AccountInputs) => LocalizedString} */
const bn_signin_no_account = en_signin_no_account;

/**
* | output |
* | --- |
* | "New to OFFSHORELABS?" |
*
* @param {Signin_No_AccountInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_no_account = /** @type {((inputs?: Signin_No_AccountInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_No_AccountInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_no_account(inputs)
	if (locale === "he") return he_signin_no_account(inputs)
	if (locale === "ur") return ur_signin_no_account(inputs)
	if (locale === "es") return es_signin_no_account(inputs)
	if (locale === "fr") return fr_signin_no_account(inputs)
	if (locale === "de") return de_signin_no_account(inputs)
	if (locale === "pt") return pt_signin_no_account(inputs)
	if (locale === "hi") return hi_signin_no_account(inputs)
	if (locale === "bn") return bn_signin_no_account(inputs)
	return /** @type {LocalizedString} */ ("New to OFFSHORELABS?")
});